module.exports = __webpack_public_path__ + "img/index-s-2.91f8d5bc.png";